import React from "react";

const PerformaceByDevice = (props) => {
  const { left, right, top, bottom } = props;
  const getFinalPerfromaceData = (data) => {
    const {
      navigationStart,
      domainLookupStart,
      domainLookupEnd,
      connectStart,
      connectEnd,
      requestStart,
      responseStart,
      responseEnd,
      domLoading,
      domComplete,
      loadEventStart,
      loadEventEnd,
      name
    } = data;
    const pageLoad = loadEventEnd - navigationStart;
    const browserProcessing = loadEventEnd - domLoading;
    const TcpConnect = connectEnd - connectStart;
    const ttfb = responseStart - requestStart;
    const response = responseEnd - responseStart;
    const domProcessing = domComplete - domLoading;
    const dns = domainLookupEnd - domainLookupStart;
    const onLoad = loadEventEnd - loadEventStart;
    return{ 
      pageLoad,
      browserProcessing,
      name,
      localData:[
      { title: "TCP CONNECT", value: TcpConnect },
      { title: "TTFB", value: ttfb },
      { title: "RESPONSE", value: response },
      { title: "DOM PROCESSING", value: domProcessing },
      { title: "DNS LOOKUP", value: dns },
      { title: "ONLOAD", value: onLoad },
    ]};
  };
  let performaceData = [];
  if (left) 
    performaceData = [getFinalPerfromaceData(left)];
  if (right)
    performaceData = [...performaceData, getFinalPerfromaceData(right)];
  if (top) 
    performaceData = [...performaceData, getFinalPerfromaceData(top)];
  if (bottom)
    performaceData = [...performaceData, getFinalPerfromaceData(bottom)];

  return (
    <div
      className={`performaceByDevice px-5 py-3 border bg-white ${
        performaceData.length > 1
          ? "d-flex flex-column justify-content-between paddingRightPerformanceDevice mt-5"
          : ""
      } `}
    >
      {[1, 3].map((item) => (
        <div
          style={{
            display: performaceData.length === 1 ? "" : "flex",
            justifyContent: "space-between",
          }}
        >
          {performaceData.map((data, index) => {
            if (item - index === 0 || item - index === 1)
              return (
                <>
                  {data.name !== undefined &&
                    <div className= {`mt-4 mb-4 ${performaceData.length === 1 ? "row":""}`}>
                      <div className={`${performaceData.length === 1 ? "col-5":"" }`}>
                        <div className="text-size-24 color-indigo-900 mb-1 fw-6">{data.name}</div>
                          <div className="color-indigo-900">Page Load {data.pageLoad} ms</div>
                          <div className="color-indigo-900">Browser Processing {data.browserProcessing} ms</div>
                        </div>
                        <div className={`${performaceData.length === 1 ? "col-7":"mt-4" } color-indigo-900`}>
                          <div className={`connectValues ${performaceData.length>1 ? "connectValuesForDoubleDevice" :""}`}>
                            {data.localData.map((d) => (
                              <div className="mt-3 mb-3 row">
                                <div className={`${performaceData.length === 1 ? "col-7":"col-10"} fw-5`}>{d.title}</div>
                                <div className={`${performaceData.length === 1 ? "col-5":"col-2"}`}>{d.value}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                    </div>
                  }
                </>
              );
          })}
        </div>
      ))}
    </div>
  );

};

export default PerformaceByDevice;
